
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Қыстыру',
	'find_label': 'Табу',
	'findCancelLabel': 'Болдырмау',
	'dataPaneLabel': 'Деректер',
	'sourcePaneLabel': 'Таңдалған көздер',
	'sourcePaneContentLabel': 'Көзді таңдау',
	'emptySourcePaneTitle': 'Көзді таңдау',
	'emptySourcePaneCaption': 'Бақылау тақтасын құру үшін деректерді қосу үшін дереккөзді таңдаңыз.',
	'addDataSource': 'Көзді таңдау',
	'addDataDashboardCoachMarkContents': 'Деректерді бақылау тақтасына деректер тақтасынан сүйреп апару.',
	'addDataStoryCoachMarkContents': 'Мәтіндік бөлікке деректер тақтасынан деректерді апарып салыңыз.',
	'addDataCoachMarkTitle': 'Деректер қосу',
	'selectSourcesText': '%{app} құру үшін деректер көзін таңдаңыз және қосыңыз.',
	'selectSourcesLabel': 'Көзді таңдау',
	'dataPreparationTitle': 'Деректерді дайындау',
	'dataPreparationCaption': 'Деректерді дайындау аяқталған кезде деректер осы жерде көрсетіледі.',
	'dataPreparationProgress': '%{percentage}% дайындалды...',
	'dataPreparationSourceError': '"%{sourceName}" үшін деректерді дайындау сәтті аяқталмады.',
	'dataPreparationStarted': '"%{sourceName}" үшін деректер дайындалуда. Деректерді дайындау аяқталған кезде бақылау тақтасының мүмкіндіктері қолжетімді болады.',
	'dataPreparationComplete': '"%{sourceName}" үшін деректерді дайындау аяқталды. Ол енді бақылау тақтасының барлық мүмкіндіктерімен пайдалануға дайын.',
	'preparingData': 'Деректер дайындалуда...',
	'moserUnsupportedSourceType': 'Бұл деректер көзінің түріне қолдау көрсетілмейді.',
	'errorSourcesTitle': 'Деректер тармағын жүктеу сәтсіз аяқталды',
	'errorLoadingDataSources': 'Дерек жиындарының тізімін жүктеу кезінде қателік пайда болды',
	'errorLoadingDataTree': 'Тармақты жүктеу кезінде орын алған қате',
	'dataSetPaneLastUpdated': 'Соңғы жаңартылған: %{date}',
	'dataSourcePaneDateUnknown': 'Белгісіз',
	'moreTitle': 'Қосымша',
	'backLabel': 'Қайту',
	'addDataSourceDialogTitle': 'Көзді таңдау',
	'addDataSourceDialogButtonLabel': 'Қосу',
	'dlg_use': 'Пайдалану',
	'dlg_RelinkDataSourceTitle': '"%{dataSourceName}" мәліметтер жиынын келесімен ауыстырыңыз ...',
	'propertiesDialogTitle': 'Сипаттар',
	'missingDataSetData': 'Бұл деректер жиыны үшін деректер қолжетімсіз келеді. Көзге қатынас үшін әкімшіңізге қатынас орнатыңыз немесе деректер жиыныңызды жаңартыңыз.',
	'errorMessageTitle': 'Қате',
	'calculation_navigation_in_use': 'Есептеулерді, сүзгілерді немесе навигациялық жолдарды жою жойылған элементке сілтеме жасайтын барлық визуализацияларды жарамсыз етеді. Жойылуын қалайсыз ба?',
	'delete_confirm': 'Жоюды растау',
	'previewUnavailable': 'Деректер науасы және жаһандық сүзгілер осы бума түріне қол жетімді емес.',
	'contextualGridTabName': 'Көрнекілендіру деректері',
	'DATA_TRAY_no_data_text': 'You don\'t currently have any data',
	'contextualGridMenuLabel': 'Көрнекілендіру деректер мəзірі',
	'contextualGridExport': 'Экспорттау',
	'nullValueText': 'Бос мән',
	'relationships_title': 'Қарым-қатынастар',
	'forecastDetailsTabName': 'Статистикалық мәліметтерді болжау',
	'forecastDetailsModelLabel': 'Үлгі',
	'forecastDetailsQualityMetricLabel': 'Дәлдік шаралары',
	'forecastDetailsSmoothingCoefLabel': 'Параметрлер',
	'forecastDetailsDiagnostics': 'Диагностика',
	'forecastDetailsForecastLabel': 'Болжам',
	'forecastDetailsStatusLabel': 'Күй',
	'forecastDetailsAccuracyPercentLabel': 'Дәлдігі %',
	'forecastDetailsTrendLabel': 'Тренд',
	'forecastDetailsSeasonLabel': 'Маусымдық',
	'forecastDetailsSeasonalPeriodLabel': 'Маусымдық кезең',
	'forecastDetailsAlphaLabel': 'Альфа',
	'forecastDetailsBetaLabel': 'Бета',
	'forecastDetailsGammaLabel': 'Гамма',
	'forecastDetailsPhiLabel': 'Фи',
	'forecastDetailsMissingCount': 'Жоқ санау',
	'forecastDetailsSeriesLengthLabel': 'Серия ұзындығы',
	'forecastDetailsIgnoredPeriods': 'Еленбеген кезеңдер',
	'forecastDetailsTrendStrength': 'Трендтің күші',
	'forecastDetailsSeasonalityStrength': 'Маусымның күші',
	'forecastDetailsTimeDeltaUnit': 'Күн / уақыт аралығы',
	'forecastDetailsNotes': 'Жазбалар',
	'DatasetRefresh_AmbiguousConnection': ' Келесі қосылым мәселесін шешу үшін «Деректер жинағын өңдеу» опциясын пайдаланыңыз: %{errorMessage}'
});
